module.exports = __webpack_public_path__ + "static/media/thumb.7399f1f0.jpg";